import React from 'react'

/* doc
---
title: ModalCardTitle
name: ModalCardTitle
category: React - Bulma
---

A `ModalCardTitle` component based on Bulma `.modal-card-title`. The title for a modal ModalCard

This should be used with `ModalCard`

See [Bulma Documentation](http://bulma.io/documentation/components/modal/) for reference and full options.

```html_example
  <Modal>
    <ModalBackground />
    <ModalCard>
      <ModalCardHead>
        <ModalCardTitle>
          ...
        </ModalCardTitle>
      </ModalCardHead>
      <ModalCardBody>
        ...
      </ModalCardBody>
      <ModalCardFoot>
        ...
      </ModalCardFoot>
    </ModalCard>
  </Modal>
```
*/
function ModalCardTitle(props) {
  const { className, children, ...rest } = props

  const classes = [
    'bulma-modal-card-title',
    className || '',
  ]

  return (
    <p {...rest} className={classes.join(' ')}>
      {children}
    </p>
  )
}

export default ModalCardTitle
